import { useEffect, useState } from 'react'

// Stejný breakpoint jako `@media (min-width: 768px)` v layout-1.css / left-sidebar-1.css.
// Pod ním má `config.collapsed` jiný význam (mobil = otevřené/zavřené off-canvas menu,
// desktop = úzká ikonová lišta) — proto komponenty potřebují vědět, na které straně jsme.
const QUERY = '(min-width: 768px)'

export default function useIsDesktop() {
    const [isDesktop, setIsDesktop] = useState(
        () => typeof window !== 'undefined' && window.matchMedia(QUERY).matches
    )

    useEffect(() => {
        const mql = window.matchMedia(QUERY)
        const onChange = (e) => setIsDesktop(e.matches)
        mql.addEventListener('change', onChange)
        return () => mql.removeEventListener('change', onChange)
    }, [])

    return isDesktop
}
